export const joinNotificationEmails = (emails: string[] | null | undefined): string => (emails ?? []).join(", ");

export const parseNotificationEmails = (value: string | undefined): string[] | null => {
  const emails = (value ?? "")
    .split(",")
    .map((email) => email.trim())
    .filter(Boolean);
  return emails.length > 0 ? emails : null;
};
